import React, { useState, useEffect, useRef } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import { syncOfflineOrders } from "utils"
import classes from "./OfflineOrderSyncButton.module.scss"

const OfflineOrderSyncButton = () => {
  const [t] = useTranslation()

  const offlineOrders =
    useSelector(state => state.offlineOrders)

  const isOnline =
    useSelector(state => !state.internetStatus.forceOffline)

  const [loading, setLoading] = useState(false)

  const unmount = useRef(false)

  const handleSyncOfflineOrders = async () => {
    setLoading(true)

    await syncOfflineOrders()

    if (unmount.current) return

    setLoading(false)
  }

  const haveOfflineOrders = offlineOrders.length > 0

  useEffect(() => {
    unmount.current = false

    return () => unmount.current = true
  }, [])

  if (!isOnline) return null

  if (!haveOfflineOrders) return null

  return (
    <div className={classes["footer"]}>
      <Button
        color="info"
        className={classes["button"]}
        loading={loading}
        onClick={handleSyncOfflineOrders}
      >
        {t("همگام_سازی_سفارشات")}
      </Button>
    </div>
  )
}

export default OfflineOrderSyncButton